import { ChevronDownIcon } from '@heroicons/react/24/solid';
import styles from '../PlansConversionLandingPage.module.css';
import type { DemoAidaContent } from './demoComparisonTypes';

type DemoAidaResponseProps = {
  content: DemoAidaContent;
  contentKey: string;
};

export default function DemoAidaResponse({ content, contentKey }: DemoAidaResponseProps) {
  return (
    <div className={styles.demoAidaResponse}>
      <p className={styles.demoAidaQuestion}>
        <span className={styles.demoAidaQuestionLabel}>Question</span>
        {content.question}
      </p>

      <details key={contentKey} className={styles.demoAidaDetails}>
        <summary className={styles.demoAidaSummary}>
          <span>View full answer</span>
          <ChevronDownIcon className={styles.demoAidaChevron} aria-hidden />
        </summary>
        <div className={styles.demoAidaBody}>
          <h4 className={styles.demoAidaAnswerTitle}>{content.title}</h4>
          <p className={styles.demoAidaContext}>{content.context}</p>
          <h5 className={styles.demoAidaSectionTitle}>{content.sectionTitle}</h5>
          <ul className={styles.demoAidaEntries}>
            {content.entries.map(entry => (
              <li key={entry.heading} className={styles.demoAidaEntry}>
                <p className={styles.demoAidaEntryHeading}>{entry.heading}</p>
                <ul className={styles.demoAidaEntryLines}>
                  {entry.lines.map(line => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
          <div className={styles.demoAidaTakeaway}>
            <p className={styles.demoAidaTakeawayLabel}>Takeaway</p>
            <p className={styles.demoAidaTakeawayText}>{content.takeaway}</p>
          </div>
        </div>
      </details>
    </div>
  );
}
